"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetricDefinitionInterceptor = exports.getMetricsFollowerCounts = exports.getBatchMetrics = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
const restApiVersion = '-';
const PULSE_PREFIX = 'pulse';
const DEFINITIONS_PREFIX = 'definitions';
const FOLLLOWERS_PREFIX = 'subscriptions:batchGetMetricFollowerCounts';
const BATCHGET_PREFIX = 'batchGet';
const FULLVIEW_PREFIX = 'DEFINITION_VIEW_FULL';
const MAX_NUMBER_OF_METRICS_PER_PAGE = 10000; // TODO Linda
function getBatchMetrics({ definitionIds, makeJsonRestApiRequest }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!definitionIds || definitionIds.length === 0) {
            return {
                definitions: [],
            };
        }
        const config = {
            endpoint: `${PULSE_PREFIX}/${DEFINITIONS_PREFIX}:${BATCHGET_PREFIX}`,
            httpMethod: 'GET',
            restApiVersion,
            serverWideRequest: true,
        };
        const queryParams = {
            definition_ids: definitionIds.toString(),
            view: FULLVIEW_PREFIX,
            number_of_metrics: MAX_NUMBER_OF_METRICS_PER_PAGE,
        };
        const result = yield makeJsonRestApiRequest(config, undefined, queryParams);
        return result;
    });
}
exports.getBatchMetrics = getBatchMetrics;
function getMetricsFollowerCounts({ metricIds, makeJsonRestApiRequest }) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (!metricIds || metricIds.length === 0) {
            return {
                follower_counts: [],
            };
        }
        const config = {
            endpoint: `${PULSE_PREFIX}/${FOLLLOWERS_PREFIX}`,
            httpMethod: 'GET',
            restApiVersion,
            serverWideRequest: true,
        };
        const queryParams = {
            metric_ids: metricIds.toString(),
        };
        const result = yield makeJsonRestApiRequest(config, undefined, queryParams);
        return result;
    });
}
exports.getMetricsFollowerCounts = getMetricsFollowerCounts;
function getCountsFromResponses(metricResponse, followerResponse, t) {
    var _a, _b, _c;
    const metricDefinition = metricResponse.definitions.find((def) => def.metadata.id === t.luid);
    const metricsCount = (_b = Number((_a = metricDefinition === null || metricDefinition === void 0 ? void 0 : metricDefinition.total_metrics) !== null && _a !== void 0 ? _a : 0)) !== null && _b !== void 0 ? _b : 0;
    const metricsInDefinition = (_c = metricDefinition === null || metricDefinition === void 0 ? void 0 : metricDefinition.metrics.map((m) => m.id)) !== null && _c !== void 0 ? _c : [];
    const followersInDefinition = followerResponse
        .follower_counts
        .filter((m) => {
        return metricsInDefinition.includes(m.metric_id);
    });
    const followersCount = followersInDefinition.reduce((acc, curr) => acc + curr.follower_count, 0);
    return {
        metricsCount,
        followersCount,
    };
}
function useMetricDefinitionInterceptor() {
    const getBatchMetricsFn = (0, catalog_core_1.useRestFn)(getBatchMetrics);
    const getMetricsFollowerCountsFn = (0, catalog_core_1.useRestFn)(getMetricsFollowerCounts);
    return react_1.default.useCallback((arr) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const definitionIds = arr.items.map(t => t.luid);
        const metricsResp = yield getBatchMetricsFn({ definitionIds });
        const metricIds = metricsResp.definitions.flatMap((def) => {
            return def.metrics.map((metric) => {
                return metric.id;
            });
        });
        const followersResp = yield getMetricsFollowerCountsFn({ metricIds });
        const sliceItems = arr.items.map((t) => {
            const { metricsCount, followersCount } = getCountsFromResponses(metricsResp, followersResp, t);
            return Object.assign(Object.assign({}, t), { metricsCount, followersCount });
        });
        return Object.assign(Object.assign({}, arr), { items: sliceItems });
    }), [getBatchMetricsFn, getMetricsFollowerCountsFn]);
}
exports.useMetricDefinitionInterceptor = useMetricDefinitionInterceptor;
//# sourceMappingURL=MetricDefinitionFetcher.js.map